import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AddressApi from 'lib/api/address'
import { withI18next } from 'lib/i18n/withI18next'
import BasePage from 'pages/base'
import CommonLayout from 'components/layout/common'
import HowItWorksSection from 'components/pomelo-pickup/how-it-works-section'
import ResponsiveImage from 'components/images/responsive-image'
import GoogleMapSearchFilter from 'components/google-map-search-filter'
import VisualImagesAPI from 'lib/api/visual-images'
import Loader from 'components/loader'
import styles from './styles.scss'

class PomeloPickUp extends BasePage {
  static getInitialProps({ store, req, res, isServer }) {
    if (isServer) {
      BasePage.loadInitialContentFromServer({ req, res, store })
    } else {
      BasePage.loadInitialContentFromClient(req, res, store)
    }

    return {}
  }

  state = {
    featuredLocation: null,
    locations: null,
    showCoachMark: false,
    images: null,
  }

  async afterPageMount() {
    const { internationalization: i18n } = this.props
    let stateData

    const options = {
      pickup_type: GoogleMapSearchFilter.PICKUP_TYPES,
      shop_id: i18n.shop,
    }

    const res = await AddressApi.getPickUpPoints(options)
    if (res) {
      const featuredLocation = res.pickup?.filter(
        (location) => location.is_featured,
      )
      stateData = {
        ...stateData,
        featuredLocation,
        locations: res?.pickup,
      }
    }

    const images = await VisualImagesAPI.getVisualImages({
      screen_type: 'pick_up_page',
      screen_name: 'hero_banner',
    })

    if (images && !images.error) {
      stateData = {
        ...stateData,
        images: images.hero_banner,
      }
    }

    this.setState(stateData)

    window.scroll(0, 0)

    if (!this.state.showCoachMark) {
      document.addEventListener('scroll', this.checkUserScroll)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.checkUserScroll)
  }

  checkUserScroll = () => {
    const gMapFilterElement = document.getElementById('google-map-filter-area')
    const elementToTop =
      gMapFilterElement && gMapFilterElement.getBoundingClientRect().top
    if (elementToTop <= 100) {
      // Trigger the coachmark from here
      this.setState({ showCoachMark: true })
    }
  }

  setCoachMark = () => {
    this.setState({ showCoachMark: false })
  }

  getPageMeta() {
    const { t } = this.props

    return {
      title: `${t('Pomelo Pick Up')} - Pomelo Fashion`,
      description: t(
        'An easy new way to shop. Try first and pay later at a location near you.',
      ),
    }
  }

  render() {
    const { internationalization: i18n, isPhone, t } = this.props
    const { locations, showCoachMark, images } = this.state
    let bodyJsx

    if (locations?.length) {
      let bannerSrc = null
      let bannerRatio = 0

      if (
        images &&
        images.full_square?.length > 0 &&
        images.full_landscape?.length > 0
      ) {
        bannerSrc = isPhone ? images.full_square[0] : images.full_landscape[0]
        bannerRatio = isPhone ? 1 : 0.5625
      }

      bodyJsx = (
        <React.Fragment>
          {bannerSrc && bannerRatio !== 0 && (
            <ResponsiveImage imgRatio={bannerRatio} src={bannerSrc} />
          )}
          <HowItWorksSection isPhone={isPhone} t={t} />
          {i18n.shop === 1 && (
            <GoogleMapSearchFilter
              hideTempDisabled
              t={t}
              locations={locations}
              id="google-map-filter-area"
              showCoachMark={showCoachMark}
              setCoachMark={this.setCoachMark}
            />
          )}
        </React.Fragment>
      )
    }

    return (
      <CommonLayout
        meta={this.getPageMeta()}
        showCountryModal={false}
        noSidePadding
      >
        <style jsx>{styles}</style>
        {bodyJsx || (
          <div className="loader-container">
            <Loader />
          </div>
        )}
      </CommonLayout>
    )
  }
}

PomeloPickUp.propTypes = {
  t: PropTypes.func.isRequired,
  isPhone: PropTypes.bool.isRequired,
}

export { PomeloPickUp }

const Extended = withI18next(['global'])(PomeloPickUp)

export default connect(
  /* istanbul ignore next */
  (state) => ({
    internationalization: state.internationalization,
    isPhone: state.device.isPhone,
  }),
)(Extended)
